import { KSK2070_R01Dto } from "./Dto_KSK2070_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { KSK2070_R01Filter } from "./Store_KSK2070_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/KSK2070_R01`;

const getParams = (filter: Partial<KSK2070_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd,
		startDate: filter.productDateRange?.from ? formatDate(filter.productDateRange.from) : undefined,
		endDate: filter.productDateRange?.to ? formatDate(filter.productDateRange.to) : undefined,
		orderType: filter.orderType,
		workplaceCd: filter.workplaceCd,
		itemCd: filter.itemCd,
		brandCd: filter.brandCd,
		listLength: listLength || 0
	}
}

// 생산 실적 리스트 조회 (검색 조건 포함)
export const getProductResultList = async (option: string, params: Partial<KSK2070_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<KSK2070_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getProductResultAllCount = async (params: Partial<KSK2070_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}

// 신규 등록
export const createProductResult = async (data: KSK2070_R01Dto) => {
	return await postData<KSK2070_R01Dto, ResponseDto<any>>(baseUrl, data);
}

// 수정 (백엔드에서 PATCH 사용)
export const updateProductResult = async (data: KSK2070_R01Dto) => {
	return await putData<KSK2070_R01Dto, ResponseDto<any>>(baseUrl, data);
}

// 삭제 - Path parameter 사용
export const deleteProductResult = async (productResultNo: string) => {
	return await deleteData<void>(`${baseUrl}/${productResultNo}`);
}

// 엑셀 다운로드
export const exportProductResultExcel = async (option: string, params: Partial<KSK2070_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;

	const requestParams = {
		compCd: params?.compCd,
		startDate: params?.productDateRange?.from ? formatDate(params.productDateRange.from) : undefined,
		endDate: params?.productDateRange?.to ? formatDate(params.productDateRange.to) : undefined,
		orderType: params?.orderType,
		workplaceCd: params?.workplaceCd,
		itemCd: params?.itemCd,
		brandCd: params?.brandCd
	}
	return await getData<ResponseDto<string>>(url, { params: { ...requestParams, listLength } });
}
